import { DatePipe } from '@angular/common';
import { Component, ElementRef, HostListener, Input, OnInit, Optional, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { LazyLoadEvent, MessageService, SelectItem, TreeNode } from 'primeng/api';
import { helperService } from 'src/app/utils/helper';
import { ProjectTemplateService } from '../projects-template/project-template.service';
import { TaskGridService } from '../tasks-grid/task-grid.service';
import { ProjectsGridService } from './projects-grid.service';
import { ProjectContact, ProjectContactsService } from './project-contacts.service';
import { AuthGuard } from 'src/app/account/auth/app.gaurd';
import { matchModeOptionsDateList, project } from 'src/app/utils/filterDropDownData';
import { Table } from 'primeng/table';
import Swal from 'sweetalert2';
import { AppConfigService } from '../app-config/app-config.service';
import { FieldInfoGridService, FieldInfo } from '../field-info-grid/field-info-grid.service';
import { ChangeDetectorRef } from '@angular/core';
import { Dropdown } from 'primeng/dropdown';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { SavedTableState, TableStateService } from 'src/app/shared/table-state.service';
import { NotificationsService } from 'src/app/features/notifications';
import { finalize } from 'rxjs/operators';
import { TaskGridComponent } from '../tasks-grid/task-grid.component';

@Component({
    selector: 'app-projects-grid',
    templateUrl: './projects-grid.component.html',
    styleUrls: ['./projects-grid.component.scss'],
    standalone: false
})
export class ProjectsGridComponent implements OnInit {
  gridLoadError = '';
  // v13-migration placeholder (Ivy basic template-check requires the symbol to exist; undefined at runtime == v12 behaviour; Phase 2: align template)
  errorMsg: any;
  confirmationDialog: any;
  @Input()
  projectMatterFilter: any = null;

  @Input()
  projectOrgFilter: any = null;

  @Input()
  dashboard: boolean = false;

  @Input()
  tkdashboard: any = false;

  @Input()
  lpcdashboard: any = false;

  @ViewChild('orgDropdown') orgDropdown!: Dropdown;
  @ViewChild('matterDropdown') matterDropdown!: Dropdown;
  @ViewChild('dt') table!: Table;
  @ViewChild('projectNameInput') projectNameInput?: ElementRef<HTMLInputElement>;
  @ViewChild(TaskGridComponent) projectTaskGrid?: TaskGridComponent;
  tabs = [
    { label: 'Default View', key: 'default' },
    { label: 'My View', key: 'user' }
  ];
  activeTab = 'default';  
  gridSettingsDialog: boolean = false;
  defaultCols: any[] = [];
  customCols: any[] = [];
  availableColumns: any[] = [];
  isDropdownOpen: boolean = false;
  projects: any[] = [];
  tableCols: any[] = [];
  cols: any[] = [];
  matchModeOptionsString?: SelectItem[];
  matchModeOptions?: SelectItem[];
  filterDatesMatchModes: any = { startDate: 'dateIs', closedDate: 'dateIs', dueDate: 'dateIs' }
  filterDates: any = { startDate: null, closedDate: null, dueDate: null }
  dateFilters: any = []
  matchModeOptionsDate: SelectItem[] = [
    { label: 'Date Is', value: 'dateIs' },
    { label: 'Date Before', value: 'ltDate' },
    { label: 'Date After', value: 'gtDate' },
    { label: 'Date Range', value: 'betweenDate' },
  ];
  matchModeOptionsNumber?: SelectItem[];
  auditTitle: string = "";
  title: string = "";
  selectedProjectName: string = "";
  totalRecords: number = 0;
  first: number = 1;
  projectForm: any = {};
  descriptionTypes: any = [];
  practiceAreaCodes: any = [];
  newTask: any = ""
  selectedProjectForBilling: any = {}
  selectedProject: any = {}
  projectTemplates = [];
  statuses: any;
  filterOptions = project.filters;
  selectedFilterOption: string = 'All Projects';
  lpcUsersList = []
  requestedPersons = []
  TKAssignedUser: string = "";
  priorities: any;
  projectTypeCodes = {};
  mattersList: any = [];
  DbMattersList = [];
  DbOrganisations = [];
  allOrganisations: any = [];
  unAssignedTasks = [];
  taskTreeNodes: TreeNode[] = [];
  matterName: String = ""
  orgName: String = "";
  private lastTableLazyLoadEvent: any = null;
  private lastSelectedStatus: any = "Any";
  projectdueDate: any;
  defaultTime: any;
  isEnforceEstimatedTimeList: any;
  isBillableList: any;
  serviceTypes: any[] = [
    { label: 'Managed', value: 'Managed' },
    { label: 'Transactional', value: 'Transactional' },
  ];
  confirmMessage: string = "";
  projectClosedData: any;
  searchTerm: string = '';
  lastSearchTerm: any = '';
  confirmationDialogMessage: string = "";
  auditDialog: boolean = false;
  auditField:string="";
  auditRecordId:any;
  tasksloading: boolean = false;
  deleteTaskLoading: boolean = false;
  assignLoading: boolean = false;
  showConfirmAlert: Boolean = false;
  showAssignConfirmAlert: Boolean = false;
  confirmationDialogue: Boolean = false;
  showBillingConfirmAlert: Boolean = false;
  submitted: boolean = false;
  btnLoading: boolean = false;
  disableEdit: boolean = false;
  faloading: boolean = false;
  viewOnly: boolean = false;
  headerflag: boolean = false;
  reminderNotificationDialog: boolean = false;
  reminderDialog: boolean = false;
  projectDialog: boolean = false;
  assignTaskDialogue: boolean = false;
  disableSave: boolean = false;
  newProject: boolean = false;
  showProjectNotesPanel: boolean = true;
  openProjectGroups: number[] = [0, 1, 2, 3, 4];
  loading: boolean = false;
  preInvoiceDate: any;
  projGridSubscription: any;
  fieldInfoReady = false;
  viewProjectName: string = "";
  showProjectsView: boolean = false;
  projectWorkspaceTabIndex: number = 0;
  initialLoadDone: boolean = false;
  resetcustomFilter: boolean = false;

  public defaultFilters: { [s: string]: any } = {};
  notifyProjectIdPayload: any = null;
  // Filters from widget or entity navigation
  widgetFilters: any[] = [];
  filterSource: string = ''; // 'widget' or 'entity'
  private navigationSubscription: any;
  private isDestroyed: boolean = false;


  screenName: string = "project_grid";

  constructor(private datePipe: DatePipe, private projectService: ProjectsGridService, private taskService: TaskGridService,
    private projectTemplateService: ProjectTemplateService, private readonly messageService: MessageService,
    private filterService: helperService, private authService: AuthGuard, private appConfigService: AppConfigService,
    private fieldInfoService: FieldInfoGridService, private cdr: ChangeDetectorRef, private notificationService: NotificationsService,
    private tableStateService: TableStateService,private route: ActivatedRoute , private router: Router,
    private projectContactsService: ProjectContactsService) {
       this.navigationSubscription = this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
              // Skip if component is destroyed
              if (this.isDestroyed) {
                return;
              }
              
              // Only handle navigation updates after initial load is complete
              // This prevents interference with restoreTaskState during component initialization
              if (!this.initialLoadDone) {
                return;
              }
              
              // Check history.state for navigation data
              const state = history.state;
              if (state && state.filters && (state.fromWidget || state.fromEntity || state.fromScreen)) {
                this.widgetFilters = state.filters;
                this.filterSource = state.fromWidget ? 'widget' : 'entity';
                this.filterSource = state.fromScreen ? state.fromScreen : this.filterSource;
                setTimeout(() => {
                  this.applyWidgetFiltersToUI();
                  if (this.lastTableLazyLoadEvent) {
                    this.loadProjectsData(this.lastTableLazyLoadEvent);
                  }
                }, 100);
              }
            }
          });
     }

  ngOnInit(): void {
    console.log("Recieved projectOrgFilter in projects component:", this.projectOrgFilter);
    console.log("Recieved projectMatterFilter in projects component:", this.projectMatterFilter);
    this.route.queryParamMap.subscribe(params => {
      const projectId = params.get('projectId'); 

      if (projectId && !isNaN(parseInt(projectId))) {
        const idValue = parseInt(projectId, 10);

        this.notifyProjectIdPayload = {
          filters: [{ field: "projectId", operator: "equals", value: idValue }],
          sort: [],
          category: "All Tasks",
          searchTerm: ""
        };
        
        console.log('Payload updated:', this.notifyProjectIdPayload);
        this.loadProjectsData(this.notifyProjectIdPayload);
      }else{
        console.log('Invalid projectId parameter:', projectId);
        this.notifyProjectIdPayload = null;
      }
    });
    // Check for navigation state from widgets or entities using history.state
    const state = history.state;
    if (state && state.filters && (state.fromWidget || state.fromEntity || state.fromScreen)) {
      this.widgetFilters = state.filters;
      this.filterSource = state.fromWidget ? 'widget' : 'entity';
      this.filterSource = state.fromScreen ? state.fromScreen : this.filterSource;
      console.log('Filters applied from:', this.filterSource, this.widgetFilters);
    }

    this.fieldInfoService.fetchAllFieldsOnce().then(() => {
      this.fieldInfoReady = true;
      this.cdr.detectChanges();
    });

    if (this.filterService.isOnlyTKUser(this.authService.roles) || (this.authService.roles.length > 1 && this.tkdashboard)) {
      this.disableEdit = true;
    }
    this.defaultTime = new Date();
    this.isEnforceEstimatedTimeList = project.isEnforceEstimatedTimeList;
    this.isBillableList = project.isBillableList;
    if (Array.isArray(project.serviceTypes) && project.serviceTypes.length) {
      this.serviceTypes = project.serviceTypes;
    }
    this.priorities = project.priorities;
    this.statuses = project.statuses;
    this.defaultTime.setHours(0, 0, 0, 0);
    this.projectForm = new UntypedFormGroup({

      name: new UntypedFormControl('', [Validators.required]),
      projectTemplateId: new UntypedFormControl(''),
      startDate: new UntypedFormControl('', [Validators.required]),
      closedDate: new UntypedFormControl(''),
      dueDate: new UntypedFormControl('', [Validators.required]),
      estimatedTime: new UntypedFormControl(''),
      actualTime: new UntypedFormControl(''),
      estimatedBudget: new UntypedFormControl(''),
      // , [ Validators.pattern('^[0-9]*(\.[0-9]{0,2})?$')]
      isEnforceEstimatedTime: new UntypedFormControl('', [Validators.required]),
      isForceRequestedBy: new UntypedFormControl(''),
      projectTypeId: new UntypedFormControl('', [Validators.required]),
      statusCode: new UntypedFormControl('', [Validators.required]),
      priorityCode: new UntypedFormControl('', [Validators.required]),
      lpcUserId: new UntypedFormControl('', [Validators.required]),
      isBillable: new UntypedFormControl('', [Validators.required]),
      serviceType: new UntypedFormControl('Transactional'),
      notes: new UntypedFormControl(''),
      description: new UntypedFormControl(''),
      requestedBy: new UntypedFormControl(''),
      matterId: new UntypedFormControl('', [Validators.required]),
      organizationId: new UntypedFormControl('', [Validators.required]),
      organizationName: new UntypedFormControl(''),
      matterName: new UntypedFormControl(''),
      projectTemplateName: new UntypedFormControl(''),
      id: new UntypedFormControl({ value: '', disabled: true }),
      actualSpend: new UntypedFormControl(''),
      holdTimeUntilCompleted: new UntypedFormControl('', [Validators.required]),
      dbProjectStatusCode: new UntypedFormControl(''),
      dbProjectholdTimeUntilCompleted: new UntypedFormControl(''),
      isPreInvoiced: new UntypedFormControl('', [Validators.required]),
      invoiceNumber: new UntypedFormControl('', [Validators.pattern('^[a-zA-Z0-9_-]+$')]),
      isInvoicePaid: new UntypedFormControl(''),
      submitToBilling: new UntypedFormControl(''),
      submitToBillingEnabled: new UntypedFormControl(''),
      isInvoicePaidString: new UntypedFormControl(''),
      isPreInvoicedDb: new UntypedFormControl(''),
      projectTaskCount: new UntypedFormControl(''),
      dueDateChangeCount: new UntypedFormControl(''),
      projectStatusChangeCount: new UntypedFormControl(''),
      completedChangeCount: new UntypedFormControl(''),
      assignmentStatusChangeCount: new UntypedFormControl(''),
      nonBillableReason: new UntypedFormControl(''),
      unreadReminderNotificationCount: new UntypedFormControl(''),
      unreadReminderNotifications: new UntypedFormControl(''),
    });

   

    this.tableCols = [
      // { field: 'name', header: 'Project Name' },
      // { field: 'id', header: 'Project ID', showHistoryIcon: false ,visible: true},
      { field: 'organizationName', header: 'Organization Name', showHistoryIcon: false ,visible: true},
      { field: 'matterName', header: 'Matter Name', showHistoryIcon: false ,visible: true},
      { field: 'projectTemplateName', header: 'Template Assigned', showHistoryIcon: false ,visible: true},
      { field: 'submitToBilling', header: 'Billing Submitted', showHistoryIcon: false ,visible: true},
      // { field: 'submitToBillingEnabled', header: 'submitToBilling', showHistoryIcon: false },
      { field: 'isPreInvoiced', header: 'Pre Invoiced', showHistoryIcon: false , visible: true},
      { field: 'isInvoicePaid', header: 'Invoice Paid', showHistoryIcon: false , visible: true},
      { field: 'serviceType', header: 'Service Type', showHistoryIcon: false , visible: true},
      { field: 'description', header: 'Description', showHistoryIcon: false , visible: true},
      { field: 'holdTimeUntilCompleted', header: 'Hold Time Until Completed', showHistoryIcon: false , visible: true},
      { field: 'estimatedTime', header: 'Estimated Time',disableActions:true, showHistoryIcon: false , visible: true},
      { field: 'estimatedBudget', header: 'Estimated Budget', showHistoryIcon: false , visible: true},
      { field: 'isEnforceEstimatedTime', header: 'Enforced Estimated Time',disableActions:true, showHistoryIcon: false , visible: true},
      { field: 'actualSpend', header: 'Actual Spend',disableActions:true, showHistoryIcon: false , visible: true},
      { field: 'actualTime', header: 'Actual Time',disableActions:true, showHistoryIcon: false , visible: true},
      { field: 'startDate', header: 'Start Date', showHistoryIcon: false , visible: true},
      { field: 'closedDate', header: 'Close Date', showHistoryIcon: false , visible: true},
      { field: 'dueDate', header: 'Due Date', showHistoryIcon: true, visible: true },
      { field: 'projectTypeCode', header: 'Project Type', showHistoryIcon: false , visible: true},
      { field: 'statusCode', header: 'Status', showHistoryIcon: true , visible: true},
      { field: 'priorityCode', header: 'Priority', showHistoryIcon: false , visible: true},
      { field: 'createdOn', header: 'Created Date', showHistoryIcon: false , visible: true},
      { field: 'createdBy', header: 'Created By', showHistoryIcon: false , visible: true},
      { field: 'isBillable', header: 'Billable', showHistoryIcon: false , visible: true},
      { field: 'lpcUserEmail', header: 'LPC', showHistoryIcon: false , visible: true}
    ];

    this.cols=this.tableCols;
    this.fetchColumnSettings();
    
    this.projectTemplateService.getTemplateList(null, null, { "filters": [{ "field": "status", "operator": "equals", "value": "Active" }], "sort": [] }, true).subscribe(res => {
      this.projectTemplates = res.data
    });

    this.projectService.getProjectTypesList().subscribe(res => {
      this.projectTypeCodes = res.data.map((template: any) => {
        return {
          id: template.id,
          label: template.description,
          value: template.code,
        };
      });

    })

    this.projectService.getLPCUsersList({
      "roles": ["LPC"],
      "userTypes": []
    }).subscribe(res => {
      this.lpcUsersList = res.data;
    })

    this.projectService.getAllMatters({}).subscribe(res => {
      this.mattersList = res.data.map((item: any) => ({
              id: item.matterId,
              name: item.matterName,
              orgName: item.orgName,
              orgId: item.orgId
            }));
      this.DbMattersList = this.mattersList
    })

    this.projectService.getAllOrganizations().subscribe(res => {
      this.allOrganisations = res.data.map((org: any) => { return { id: org.id, name: org.name, value: org.id } });
      this.DbOrganisations = this.allOrganisations
    })

    this.projectForm.get('isBillable').valueChanges.subscribe((isBillable: any) => {
      const nonBillableControl = this.projectForm.get('nonBillableReason');
      if (isBillable === 'Yes') {
        nonBillableControl?.clearValidators();
        nonBillableControl?.disable({ emitEvent: false });
      } else {
        nonBillableControl?.setValidators([Validators.required]);
        nonBillableControl?.enable({ emitEvent: false });
      }
      nonBillableControl?.updateValueAndValidity({ emitEvent: false });
    });

    const saved = this.tableStateService.getState(this.screenName+this.activeTab, this.authService.jwtData.email) as SavedTableState;

    if (saved && !this.initialLoadDone) {
      this.restoreSavedState(saved);
    }
  }
  checkPreInvoiced(isPreInvoiced: any) {
    if (this.checkPreInvoicedNewProject(this.projectForm.getRawValue()) || !this.projectForm.getRawValue().createdOn) {
      if (isPreInvoiced != "Yes") {
        this.projectForm.controls['invoiceNumber'].disable();
        this.projectForm.controls['isInvoicePaid'].disable();
      } else if (this.projectForm.controls['submitToBilling']?.value == "Yes" && this.authService.roles.includes("Billing")) {
        this.projectForm.controls['invoiceNumber'].enable();
        if (!this.projectForm.controls['invoiceNumber']?.value) {
          this.projectForm.controls['isInvoicePaid'].enable();
        }
      }
      if (this.projectForm.controls['statusCode'].value != 'Submitted to Billing') {
        if (isPreInvoiced == "Yes" && !this.projectForm.controls['invoiceNumber']?.value) {
          this.projectForm.patchValue({ statusCode: 'Pending Payment' });
          this.projectForm.controls['statusCode'].disable();
        }
        else if (isPreInvoiced == "Yes" && this.projectForm.controls['invoiceNumber']?.value) {
          this.projectForm.controls['statusCode'].enable();
        }
        else if (isPreInvoiced != "Yes") {
          this.projectForm.patchValue({ statusCode: 'In Progress' });
          this.projectForm.controls['statusCode'].enable();
        }
      }

    }
  }

  /**
   * Builds the payload with filters, sort, category, and searchTerm
   * Reusable for both data loading and export operations
   */
  buildProjectPayload(event: LazyLoadEvent): any {
    let payload = this.filterService.generateEventPayload(event);

    // Add matter filter if exists
    if (this.projectMatterFilter) {
      payload.filters.push({
        "field": "matterId",
        "operator": "equals",
        "value": this.projectMatterFilter
      });
    }

    // Add organization filter if exists
    if (this.projectOrgFilter) {
      payload.filters.push({
        "field": "organizationId",
        "operator": "equals",
        "value": this.projectOrgFilter
      });
    }

    // // Add status filter if exists
    // if (this.lastSelectedStatus && this.lastSelectedStatus != 'Any') {
    //   payload.filters.push({
    //     "field": "statusCode",
    //     "operator": "equals",
    //     "value": this.lastSelectedStatus
    //   });
    // }

    // Add category-specific filters
    if (this.selectedFilterOption == 'My Projects') {
      payload["category"] = "My Projects";
      payload.filters.push(
        {
          "field": "createdBy",
          "operator": "equals",
          "value": this.authService.jwtData.email,
          "logicGrp": "OR"
        }
      );
      payload.filters.push(
        {
          "field": "lpcUserEmail",
          "operator": "equals",
          "value": this.authService.jwtData.email,
          "logicGrp": "OR"
        }
      );
    } else {
      payload["category"] = "All Projects";
    }

    // Add date filters
    if (this.dateFilters) {
      payload.filters = payload.filters.concat(this.dateFilters);
    }

    if (this.widgetFilters && this.widgetFilters.length > 0) {
      const widgetFilterFields = this.widgetFilters.map((f: any) => f.field);
      payload.filters = payload.filters.filter((f: any) => !widgetFilterFields.includes(f.field));
      payload.filters = payload.filters.concat(this.widgetFilters);
    }

    // Add search term
    payload["searchTerm"] = this.searchTerm;
    let isDashboardFlag = this.filterService.useDashboardUrl(this.authService.roles, this.tkdashboard);
    if (isDashboardFlag) {
      // Change all filters with field 'id' to 'projectId'
      payload.filters = payload.filters.map((filter: any) => {
        if (filter.field === 'id') {
          return { ...filter, field: 'projectId' };
        }
        return filter;
      });
      // Change all sorts with field 'id' to 'projectId'
      if (payload.sort && Array.isArray(payload.sort)) {
        payload.sort = payload.sort.map((sortObj: any) => {
          if (sortObj.field === 'id') {
            return { ...sortObj, field: 'projectId' };
          }
          return sortObj;
        });
      }
    }

    return payload;
  }

  loadProjectsData(event: LazyLoadEvent, assignOperation?: Boolean, selectedStatus?: any, table?: Table) {
    event = event ? event : this.lastTableLazyLoadEvent || { first: 0, rows: 10 };
    if (!this.notifyProjectIdPayload) {
      this.saveState(event);
      this.lastTableLazyLoadEvent = event;
    }

    if (assignOperation)
      this.loading = false;
    else
      this.loading = true;
    this.gridLoadError = '';

    if (!this.preInvoiceDate) {
      this.appConfigService.getConfigurationsById(null).subscribe((res: any) => {
        let preInvoicedDate = res?.data?.filter((obj: any) => obj.name == "Preinvoice Launch");
        this.preInvoiceDate = preInvoicedDate?.length > 0 && preInvoicedDate[0].value ? new Date(preInvoicedDate[0].value) : new Date();
        this.loadProjectDataAfterConfig(event, assignOperation, selectedStatus, table)
      })
    } else {
      this.loadProjectDataAfterConfig(event, assignOperation, selectedStatus, table)
    }

  }

  loadProjectDataAfterConfig(event: LazyLoadEvent, assignOperation?: Boolean, selectedStatus?: any, table?: Table) {
    let isDashboardFlag = this.filterService.useDashboardUrl(this.authService.roles, this.tkdashboard);
    let payload: any = {};
    if (this.notifyProjectIdPayload) {
      payload = this.notifyProjectIdPayload
      this.lastSearchTerm = "";
      event.first = 1;
      event.rows = 10;
    } else {
      if (selectedStatus && selectedStatus != this.lastSelectedStatus) {
        event.first = 1;
        event.rows = 10;
        this.lastSelectedStatus = selectedStatus
        this.totalRecords = 0;
      } else {
        // this.lastSelectedStatus=selectedStatus
        event.first = event.first ? event.first : 1;
        event.rows = event.rows ? event.rows : 10;
      }

      if (table) {
        table._first = 0;
        event.first = 1;
        event.rows = 10;
      }

      payload = this.buildProjectPayload(event);

      if (this.lastSearchTerm != this.searchTerm) {
        event.first = 1
      }
      this.lastSearchTerm = this.searchTerm;
    }

    if (this.projGridSubscription)
      this.projGridSubscription.unsubscribe();
    
    this.projGridSubscription = this.projectService.getProjectsList(Math.floor(event.first / event.rows + 1), event.rows,isDashboardFlag, payload).subscribe(res => {
      this.projects = res?.data || [];
      if (this.assignLoading) {
        this.loading = false;
        this.assignLoading = false;
        this.messageService.add({ severity: 'success', detail: 'Task details have been assigned successfully' });
      }
      if (this.deleteTaskLoading) {
        this.loading = false;
        this.deleteTaskLoading = false;
        this.messageService.add({ severity: 'success', detail: 'Task details have been deleted successfully' });
      }
      this.projects.forEach(obj => {
        obj.actualSpend = obj.actualSpend ? (obj.actualSpend).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        }) : '$0.00';
        obj.estimatedBudget = obj.estimatedBudget ? (obj.estimatedBudget).toLocaleString('en-US', {
          style: 'currency',
          currency: 'USD',
        }) : '$0.00';
        obj['disableEditProject'] = false;
        obj["disableManageReminders"] = false;
        obj['disableManageRemindersTitle'] = "Cannot manage reminders: Project is completed.";
        obj['disableEditProjectTitle'] = "Cannot edit project: Project is not in an editable state.";
        obj['disableAssignProjectTitle'] = "Cannot assign task: Project is not in an assignable state.";
        obj['submitToBillingTitle'] = "Submit this project to billing.";
        obj['viewProjectTitle'] = "View project details.";
        obj['editProjectTitle'] = "Edit project details.";
        obj['createTaskTitle'] = "Create a new task for this project.";
        obj['dbProjectStatusCode'] = obj.statusCode;
        obj['dbProjectholdTimeUntilCompleted'] = obj.holdTimeUntilCompleted;
        obj['disableAssignProject'] = false;
        obj['isPreInvoicedDb'] = obj.isPreInvoiced;
        // //HARDCODED
        obj['submitToBillingEnabled'] = false
        // obj['submitToBilling']='Yes'
        if (this.checkPreInvoicedNewProject(obj)) {
          if (obj['isPreInvoiced'] == "Yes") {
            obj['submitToBillingEnabled'] = true;
            obj['submitToBillingTitle'] = "Submit this project to billing.";
          }
        }
        if (obj['submitToBilling'] == "Yes") {
          obj['submitToBillingEnabled'] = false;
          obj['submitToBillingTitle'] = "Cannot submit: Project already submitted to billing.";
        }
        // obj['submitToBillingEnabled']=true

        if (obj.statusCode != 'Pending Payment' && obj.statusCode != 'In Progress' && obj.statusCode != 'On Hold') {
          obj['disableEditProject'] = true;
          obj['disableEditProjectTitle'] = "Cannot edit: Project status is not editable (" + obj.statusCode + ").";
          obj['disableAssignProject'] = true;
          obj['disableAssignProjectTitle'] = "Cannot assign: Project status is not assignable (" + obj.statusCode + ").";
        }
        if (this.checkPreInvoicedNewProject(obj)) {
          if (obj['submitToBilling'] == "Yes") {
            obj['disableEditProject'] = true;
            obj['disableEditProjectTitle'] = "Cannot edit: Project has been submitted to billing.";
          }
        }
        if (obj.closedDate && this.filterService.isPastDate(new Date(obj.closedDate))) {
          obj['disableEditProject'] = true;
          obj['disableEditProjectTitle'] = "Cannot edit: Project is closed and past the closed date.";
        }
        else if (this.filterService.isPastDate(new Date(obj.dueDate))) {
          obj['disableEditProject'] = true;
          obj['disableEditProjectTitle'] = "Cannot edit: Project is past the due date.";
        }

        if (this.checkPreInvoicedNewProject(obj)) {
          if (this.authService.roles.includes("Billing")) {//&& this.authService.roles.length==1
            if (obj['submitToBilling'] == "Yes" && obj['isInvoicePaid'] == 'Yes') {
              obj['disableEditProject'] = true;
              obj['disableEditProjectTitle'] = "Cannot edit: Invoice is paid for this project.";
            } else if (obj['submitToBilling'] == "Yes" && obj['isInvoicePaid'] != 'Yes') {
              obj['disableEditProject'] = false;
              obj['disableEditProjectTitle'] = "Edit project details.";
            }
            obj['disableAssignProject'] = true;
            obj['disableAssignProjectTitle'] = "Cannot assign: Billing user cannot assign tasks.";
          }
        }

        if (this.filterService.isAdminUser(this.authService.roles) || (this.filterService.isLPCUser(this.authService.roles))) {//&& obj['submitToBilling']!="Yes"
          obj['disableEditProject'] = false;
          obj['disableEditProjectTitle'] = "Edit project details.";
          obj['disableAssignProject'] = false;
          obj['disableAssignProjectTitle'] = "Assign tasks to project.";
        }

        if ((obj.closedDate && this.filterService.isPastDate(new Date(obj.closedDate))) || (obj.statusCode?.toUpperCase() == 'COMPLETED' || obj.statusCode?.toUpperCase() == 'CANCELLED')) {
          obj['disableAssignProject'] = true;
          obj['disableAssignProjectTitle'] = "Cannot assign: Project is closed, completed, or cancelled.";
        }
        else if (this.filterService.isPastDate(new Date(obj.dueDate))) {
          obj['disableAssignProject'] = true;
          obj['disableAssignProjectTitle'] = "Cannot assign: Project is past the due date.";
        }

        if (this.checkPreInvoicedNewProject(obj)) {
          if (obj['isPreInvoiced'] == "Yes" && obj['submitToBilling'] == "Yes" && obj['isInvoicePaid'] != 'Yes') {
            obj['disableAssignProject'] = true;
            obj['disableAssignProjectTitle'] = "Cannot assign: Project is pre-invoiced, submitted to billing, but invoice not paid.";
          }
        }

        if(obj.statusCode?.toUpperCase() == 'COMPLETED'){
          obj['disableManageReminders'] = true;
          obj['disableManageRemindersTitle'] = "Cannot manage reminders: Project is completed.";
        }

        obj['isInvoicePaidString'] = obj.isInvoicePaid;
        obj['isInvoicePaid'] = obj.isInvoicePaid == 'Yes' ? true : false;
        obj['dueDateChangeCount'] = 1;
        obj['projectStatusChangeCount'] =1;
      })
      this.totalRecords = res?.customValues?.totalNumberOfRecords || 0;
      if (this.selectedProject?.id) {
        const refreshed = this.projects.find((obj: any) => obj.id == this.selectedProject.id);
        if (refreshed) {
          this.selectedProject = refreshed;
          this.transformTasks(refreshed);
        } else if (this.showProjectsView) {
          this.exitProjectWorkspace();
          this.messageService.add({ severity: 'info', detail: 'The project no longer matches the current grid filters, so its workspace was closed.' });
          return;
        } else {
          this.transformTasks(this.selectedProject);
        }
      }
      this.loading = false;
    }, () => {
      this.projects = [];
      this.totalRecords = 0;
      this.gridLoadError = 'Projects could not be loaded. Clear the filters and try again.';
      this.loading = false;
    })
  }
  checkPreInvoicedNewProject(project: any) {
    /*
      date1 < date2 => returns -1
      date1 = date2 => returns 0
      date1 > date2 => returns 1
    */

    if (this.filterService.compareDate(new Date(this.preInvoiceDate), new Date(project.createdOn)) <= 0) {//startDate is new
      return true;//new prodject
    }
    return false;//old 
  }

  setInvoiceConfigDate() {
    this.appConfigService.getConfigurationsById(null).subscribe((res: any) => {
      let preInvoicedDate = res.data.filter((obj: any) => obj.name == "Preinvoice Launch");
      this.preInvoiceDate = preInvoicedDate.length > 0 && preInvoicedDate[0].value ? new Date(preInvoicedDate[0].value) : new Date();
    })
  }

  addProject() {
    this.loading = true;
    this.openProjectGroups = [0, 1, 2, 3, 4];
    if (this.mattersList.length == 0) {
      this.projectDialog = true;
      this.loading = false;
      this.mattersList = this.DbMattersList;
      this.newProject = true;
      this.viewOnly = false;
      this.title = "Add Project";
      this.projectForm.reset();
      this.editContacts = [];
      this.organizationContacts = [];
      let x: any = {};
      x['statusCode'] = "In Progress";
      x['serviceType'] = "Transactional";
      this.projectForm.patchValue(x);
      this.projectForm.enable();
      this.projectForm.controls['invoiceNumber'].disable()
      this.projectForm.controls['isInvoicePaid'].disable()
    } else {
      this.newProject = true;
      this.projectDialog = true;
      this.viewOnly = false;
      this.title = "Add Project";
      this.projectForm.reset();
      this.editContacts = [];
      this.organizationContacts = [];

      this.projectForm.patchValue({ statusCode: "In Progress", serviceType: "Transactional" });
      this.projectForm.enable();
      this.projectForm.controls['invoiceNumber'].disable()
      this.projectForm.controls['isInvoicePaid'].disable()
      this.loading = false;
    }

  }
  getAllMatter(event: any) {
    this.loadOrganizationContacts(Number(event.value));
    if (event.value && Number(event.value)) {
      this.mattersList = []
      this.DbMattersList.filter((obj: any) => obj.orgId == Number(event.value)).map((obj: any) => this.mattersList.push(obj));
      // this.mattersList.sort((a: any, b: any) => (b.isDefault ?? 'N').localeCompare(a.isDefault ?? 'N'));
    } else {
      this.mattersList = []
      this.mattersList = this.DbMattersList;
    }
    if (this.orgDropdown) {
      this.orgDropdown.resetFilter();
    }
  }

  filterOrganizations(event: any) {
    console.log(event);
  }

  getOrganizationsByMatterId(event: any) {
    if (this.projectForm.controls['orgId']?.value)
      return;
    if (!event?.value || !Number(event.value)) {
      this.allOrganisations = this.DbOrganisations;
    } else {
      let matterObj: any = this.mattersList.filter((obj: any) => obj.id == Number(event.value))[0]
      let payload = {}
      if (matterObj?.name) {
        payload = {
          "filters": [{
            "field": "name",
            "operator": "equals",
            "value": matterObj.name
          }], "sort": []
        };
      }
      this.allOrganisations = []
      this.DbMattersList.filter((obj: any) => obj.name == matterObj.name).map((matter: any) => this.allOrganisations.push({ id: matter.orgId, name: matter.orgName, value: matter.orgId }));

    }

    if (this.matterDropdown) {
      this.matterDropdown.resetFilter();
    }

  }

  viewProject(projects: any, tabView?: Boolean) {
    this.mattersList = []
    this.DbMattersList.filter((obj: any) => obj.orgId == Number(projects.organizationId)).map((obj: any) => this.mattersList.push(obj));
    // this.mattersList.sort((a: any, b: any) => (b.isDefault ?? 'N').localeCompare(a.isDefault ?? 'N'));
    this.projectForm.patchValue(projects);
    this.projectForm.controls['estimatedTime'].value = this.filterService.convertTimeNumToStr(this.projectForm.controls['estimatedTime'].value)
    this.projectForm.controls['actualTime'].value = this.filterService.convertTimeNumToStr(this.projectForm.controls['actualTime'].value)
    this.projectForm.disable();
    if (!tabView) {
      this.viewOnly = true;
      this.projectDialog = true;
      this.title = "View Project: [Project ID: " + projects.id + "]"; 
    }

  }

  editProject(projects: any, tabView?: Boolean) {
    // projects['isInvoicePaid']=projects.isInvoicePaid=='Yes'?true:false;
    // this.requestedPersons = projects.requestedPersons;
    this.openProjectGroups = [0, 1, 2, 3, 4];
    this.viewOnly = false;
    this.projectForm.patchValue(projects);
    this.projectForm.enable();
    this.mattersList = []
    this.DbMattersList.filter((obj: any) => obj.orgId == projects.organizationId).map((obj: any) => this.mattersList.push(obj));
    // this.mattersList.sort((a: any, b: any) => (b.isDefault ?? 'N').localeCompare(a.isDefault ?? 'N'));

    this.projectService.getAllRequestedUsers(projects.organizationId).subscribe(res => {
      this.requestedPersons = res && res.data ? res.data : [];
    })
    this.loadOrganizationContacts(projects.organizationId);
    this.loadEditContacts(projects.id);
    this.projectForm.controls['startDate'].value = this.projectForm.controls['startDate'].value ? new Date(this.projectForm.controls['startDate'].value) : null
    this.projectForm.controls['dueDate'].value = this.projectForm.controls['dueDate'].value ? new Date(this.projectForm.controls['dueDate'].value) : null
    this.projectdueDate = this.projectForm.controls['dueDate'].value
    this.projectForm.controls['closedDate'].value = this.projectForm.controls['closedDate'].value ? new Date(this.projectForm.controls['closedDate'].value) : null;
    this.projectForm.controls['estimatedTime'].value = this.filterService.convertTimeNumToStr(this.projectForm.controls['estimatedTime'].value)
    this.projectForm.controls['actualTime'].value = this.filterService.convertTimeNumToStr(this.projectForm.controls['actualTime'].value)
    this.projectForm.controls['organizationId'].disable()
    // this.projectForm.controls['matterId'].disable()
    this.projectForm.controls['projectTemplateId'].disable()
    // this.projectForm.controls['closedDate'].disable()
    this.projectForm.controls['estimatedTime'].disable()
    this.projectForm.controls['actualTime'].disable()

    this.projectForm.controls['isPreInvoiced'].disable();
    this.projectForm.controls['invoiceNumber'].disable();
    this.projectForm.controls['isInvoicePaid'].disable();

    if (this.checkPreInvoicedNewProject(projects)) {
      this.projectForm.controls['isPreInvoiced'].enable();

      if ((this.projectForm.controls['submitToBilling']?.value == "Yes" && this.authService.roles.includes("Billing"))) {
        this.projectForm.controls['invoiceNumber'].enable();
        if (!this.projectForm.controls['isInvoicePaid']?.value) {
          this.projectForm.controls['isInvoicePaid'].enable();
        }
      } else {
        this.projectForm.controls['invoiceNumber'].disable();
        this.projectForm.controls['isInvoicePaid'].disable();
      }

      if (this.authService.roles.includes("Billing")) {// && this.authService.roles.length==1
        if (this.authService.roles.length == 1)
          this.projectForm.disable();
        if (this.projectForm.controls['submitToBilling']?.value == "Yes") {
          this.projectForm.controls['invoiceNumber'].enable();
          if (!this.projectForm.controls['invoiceNumber']?.value) {
            this.projectForm.controls['isInvoicePaid'].enable();
          }
        }
      }
      if (this.projectForm.controls['submitToBilling']?.value == "Yes") {
        this.projectForm.controls['isPreInvoiced'].disable();
        this.projectForm.controls['statusCode'].disable();
      }
      if (this.projectForm.controls['isPreInvoiced'].value == "Yes" && this.projectForm.controls['invoiceNumber']?.value) {
        this.projectForm.controls['statusCode'].enable();
      }
      // if(this.projectForm.controls['invoiceNumber']?.value) {
      //   this.projectForm.controls['invoiceNumber'].disable();
      // }
      if (this.projectForm.controls['isInvoicePaid']?.value) {
        this.projectForm.controls['isInvoicePaid'].disable();
      }
      if(this.projectForm.controls['isBillable']?.value == 'Yes'){
        this.projectForm.controls['nonBillableReason'].disable();
        this.projectForm.controls['nonBillableReason'].setValidators(null);
        this.projectForm.controls['nonBillableReason'].updateValueAndValidity();
      }else if(this.projectForm.controls['isBillable']?.value == 'No'){
        this.projectForm.controls['nonBillableReason'].enable();
        this.projectForm.controls['nonBillableReason'].setValidators([Validators.required]);
        this.projectForm.controls['nonBillableReason'].updateValueAndValidity();
      }
    }

    this.projectClosedData = this.projectForm.controls['closedDate'].value
    if (!tabView) {
      this.viewOnly = false;
      this.projectDialog = true;
      this.title = "Edit Project: [Project ID: " + projects.id + "]";
    }
    this.faloading = false;
  }

  onProjectGroupToggle(idx: any) {
    this.openProjectGroups = idx;
  }

  showFullProjectNotes: boolean = false;

  projectIdCopyState: 'copied' | 'failed' | null = null;

  copyProjectId(): void {
    const id = String(this.selectedProject?.id ?? '');
    if (!id) return;
    Promise.resolve().then(() => navigator.clipboard.writeText(id)).then(
      () => this.flashProjectIdCopyState('copied'),
      () => this.flashProjectIdCopyState('failed')
    );
  }

  dueDateOverdueDays(dueDate: any, statusCode?: string, closedDate?: any): number {
    const due = this.toLocalDate(dueDate);
    if (!due) return 0;
    const status = String(statusCode ?? '').toUpperCase();
    if (status === 'COMPLETED' || status === 'CANCELLED') return 0;
    const closed = this.toLocalDate(closedDate);
    if (closed && this.filterService.isPastDate(closed)) return 0;
    return Math.max(0, this.filterService.getDayDiff(due, new Date()));
  }

  private toLocalDate(value: any): Date | null {
    if (!value) return null;
    if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
    const m = /^(\d{1,2})\/(\d{1,2})\/(\d{4})/.exec(String(value));
    const d = m ? new Date(+m[3], +m[1] - 1, +m[2]) : new Date(value);
    return isNaN(d.getTime()) ? null : d;
  }

  private flashProjectIdCopyState(state: 'copied' | 'failed'): void {
    this.projectIdCopyState = state;
    setTimeout(() => this.projectIdCopyState = null, state === 'failed' ? 3000 : 2000);
  }

  showFullProjectDescription: boolean = false;

  private isLongText(value: any): boolean {
    const text = String(value ?? '');
    return text.length > 320 || text.split('\n').length > 6;
  }

  get projectNotesAreLong(): boolean {
    return this.isLongText(this.selectedProject?.notes);
  }

  get projectDescriptionIsLong(): boolean {
    return this.isLongText(this.selectedProject?.description);
  }

  openProjectOrganization(): void {
    const p = this.selectedProject;
    if (!p?.organizationId) return;
    this.router.navigate(['/organization'], { state: { openOrganization: { id: p.organizationId } } });
  }

  openProjectMatter(): void {
    const p = this.selectedProject;
    if (!p?.matterId) return;
    this.router.navigate(['/matters'], { state: { openMatter: { id: p.matterId } } });
  }

  isYes(value: any): boolean {
    return String(value ?? '').trim().toLowerCase() === 'yes' || value === true;
  }

  private projectMinutes(raw: any): number {
    if (raw === null || raw === undefined || raw === '') {
      return 0;
    }
    const parsed = Number(raw);
    return isNaN(parsed) ? 0 : parsed;
  }

  get projectHasEstimate(): boolean {
    return this.projectMinutes(this.selectedProject?.estimatedTime) > 0;
  }

  get projectTimeRatio(): number {
    const estimated = this.projectMinutes(this.selectedProject?.estimatedTime);
    return estimated > 0 ? (this.projectMinutes(this.selectedProject?.actualTime) / estimated) * 100 : 0;
  }

  get projectTimePercent(): number {
    return Math.max(0, Math.min(100, this.projectTimeRatio));
  }

  get projectTimeLeft(): number {
    return this.projectMinutes(this.selectedProject?.estimatedTime) - this.projectMinutes(this.selectedProject?.actualTime);
  }

  get projectTimeLeftAbs(): number {
    return Math.abs(this.projectTimeLeft);
  }

  get projectSpendRatio(): number {
    return this.projectViewBudget > 0 ? (this.projectViewSpend / this.projectViewBudget) * 100 : 0;
  }

  get projectBudgetLeftAbs(): number {
    return Math.abs(this.projectViewBudget - this.projectViewSpend);
  }

  get projectInvoiceSteps(): { label: string; state: 'done' | 'no' | 'unknown'; done: boolean }[] {
    const p = this.selectedProject;
    const paid = p && p.isInvoicePaidString !== undefined ? p.isInvoicePaidString : p?.isInvoicePaid;
    const steps: [string, any][] = [
      ['Pre-invoiced', p?.isPreInvoiced],
      ['Submitted to billing', p?.submitToBilling],
      ['Invoice paid', paid]
    ];
    return steps.map(([label, value]) => {
      const state = this.invoiceStepState(value);
      return { label, state, done: state === 'done' };
    });
  }

  private invoiceStepState(value: any): 'done' | 'no' | 'unknown' {
    if (this.isYes(value)) return 'done';
    if (value === false || String(value ?? '').trim().toLowerCase() === 'no') return 'no';
    return 'unknown';
  }

  get projectInvoiceState(): string {
    const [pre, submitted, paid] = this.projectInvoiceSteps.map(step => step.done);
    if (paid) return 'Invoice paid';
    if (submitted) return 'Submitted to billing';
    if (pre) return 'Pre-invoiced';
    return 'Not invoiced';
  }

  get projectEnforcementConflict(): boolean {
    return this.isYes(this.selectedProject?.isEnforceEstimatedTime) && !this.projectHasEstimate;
  }

  get projectViewBudget(): number {
    return this.parseCurrency(this.selectedProject?.estimatedBudget);
  }

  get projectViewSpend(): number {
    return this.parseCurrency(this.selectedProject?.actualSpend);
  }

  get hasProjectViewBudget(): boolean {
    return this.projectViewBudget > 0;
  }

  get projectSpendPercent(): number {
    if (this.projectViewBudget <= 0) {
      return 0;
    }
    return Math.max(0, Math.min(100, (this.projectViewSpend / this.projectViewBudget) * 100));
  }

  get isProjectOverBudget(): boolean {
    return this.hasProjectViewBudget && this.projectViewSpend > this.projectViewBudget;
  }

  get projectBudgetRemaining(): string {
    const left = this.projectViewBudget - this.projectViewSpend;
    return (left < 0 ? '-$' : '$') + Math.abs(left).toFixed(2);
  }

  workspaceContacts: ProjectContact[] = [];
  editContacts: ProjectContact[] = [];
  organizationContacts: ProjectContact[] = [];
  readonly contactPreviewLimit = 4;
  contactsManagerVisible: boolean = false;
  contactsManagerTarget: { projectId: number; organizationId: number; projectName: string; organizationName: string; readOnly: boolean } | null = null;
  copiedKey: string | null = null;
  discardConfirm: 'text' | 'project' | null = null;
  projectTextDialog: { field: 'description' | 'notes'; mode: 'read' | 'edit'; draft: string; saving: boolean; error: string } | null = null;

  copyToClipboard(key: string, value: any): void {
    const text = String(value ?? '');
    if (!text) return;
    Promise.resolve().then(() => navigator.clipboard.writeText(text)).then(
      () => {
        this.copiedKey = key;
        setTimeout(() => { if (this.copiedKey === key) this.copiedKey = null; }, 2000);
      },
      () => this.messageService.add({ severity: 'error', detail: 'Could not copy to clipboard' })
    );
  }

  private sortContacts(contacts: ProjectContact[]): ProjectContact[] {
    return [...contacts].sort((a, b) => Number(b.isPrimary) - Number(a.isPrimary) || a.name.localeCompare(b.name));
  }

  private loadWorkspaceContacts(projectId: number): void {
    this.workspaceContacts = [];
    if (!projectId) return;
    this.projectContactsService.getProjectContacts(projectId).subscribe(contacts => {
      if (contacts && this.selectedProject?.id === projectId) this.workspaceContacts = this.sortContacts(contacts);
    });
  }

  private loadEditContacts(projectId: number): void {
    this.editContacts = [];
    if (!projectId) return;
    this.projectContactsService.getProjectContacts(projectId).subscribe(contacts => {
      if (contacts && this.projectForm.getRawValue().id === projectId) this.editContacts = this.sortContacts(contacts);
    });
  }

  private loadOrganizationContacts(organizationId: number): void {
    this.organizationContacts = [];
    if (!organizationId) return;
    this.projectContactsService.getOrganizationContacts(organizationId).subscribe(contacts => {
      this.organizationContacts = (contacts || []).filter(c => c.isActive);
    });
  }

  private isBillingOnlyLocked(project: any): boolean {
    const roles = this.authService.roles || [];
    return roles.includes('Billing') && roles.length === 1 && !!project && this.checkPreInvoicedNewProject(project);
  }

  get canEditProjectText(): boolean {
    return !this.disableEdit && !this.selectedProject?.disableEditProject && !this.isBillingOnlyLocked(this.selectedProject);
  }

  canManageContacts(source: 'view' | 'edit'): boolean {
    if (this.isBillingOnlyLocked(source === 'edit' ? this.projectForm.getRawValue() : this.selectedProject)) return false;
    return source === 'edit' ? !this.viewOnly : (!this.disableEdit && !this.selectedProject?.disableEditProject);
  }

  openContactsManager(source: 'view' | 'edit'): void {
    const p = source === 'view' ? this.selectedProject : this.projectForm.getRawValue();
    if (!p?.id || !p?.organizationId) return;
    if (source === 'edit' && this.projectForm.controls['organizationId'].dirty) {
      this.messageService.add({ severity: 'warn', detail: 'Save the organization change before managing contacts.' });
      return;
    }
    const organizationName = p.organizationName
      || this.allOrganisations?.find((o: any) => o.id === p.organizationId)?.name || '';
    this.contactsManagerTarget = { projectId: p.id, organizationId: p.organizationId, projectName: p.name || '', organizationName, readOnly: !this.canManageContacts(source) };
    this.contactsManagerVisible = true;
  }

  onContactsSaved(projectId: number): void {
    if (this.selectedProject?.id === projectId) this.loadWorkspaceContacts(projectId);
    if (this.projectForm.getRawValue().id === projectId) this.loadEditContacts(projectId);
  }

  contactName(contact: Pick<ProjectContact, 'name'>): string {
    return contact.name;
  }

  get projectTextLabel(): string {
    return this.projectTextDialog?.field === 'notes' ? 'Notes' : 'Description';
  }

  get projectTextValue(): string {
    return this.projectTextDialog ? String(this.selectedProject?.[this.projectTextDialog.field] ?? '') : '';
  }

  get projectTextChanged(): boolean {
    return !!this.projectTextDialog && this.projectTextDialog.draft !== this.projectTextValue;
  }

  toggleProjectText(): void {
    const open = !this.showFullProjectDescription;
    this.showFullProjectDescription = open;
    this.showFullProjectNotes = open;
  }

  openProjectText(field: 'description' | 'notes', mode: 'read' | 'edit'): void {
    this.projectTextDialog = { field, mode: this.canEditProjectText ? mode : 'read', draft: String(this.selectedProject?.[field] ?? ''), saving: false, error: '' };
  }

  editProjectText(): void {
    if (this.projectTextDialog && this.canEditProjectText) this.projectTextDialog = { ...this.projectTextDialog, mode: 'edit', draft: this.projectTextValue, error: '' };
  }

  closeProjectText(): void {
    const d = this.projectTextDialog;
    if (!d || d.saving) return;
    if (d.mode === 'edit' && this.projectTextChanged) {
      this.discardConfirm = 'text';
      return;
    }
    this.projectTextDialog = null;
  }

  get discardConfirmMessage(): string {
    return this.discardConfirm === 'text'
      ? `Your ${this.projectTextLabel.toLowerCase()} changes haven’t been saved. Discard them?`
      : 'You have unsaved changes. Discard them and close?';
  }

  onDiscardConfirm(answer: string): void {
    const target = this.discardConfirm;
    this.discardConfirm = null;
    if (answer !== 'Yes') return;
    if (target === 'text') this.projectTextDialog = null;
    else this.closeDialog();
  }

  saveProjectText(): void {
    const d = this.projectTextDialog;
    if (!d || d.saving || !this.projectTextChanged || !this.canEditProjectText) return;
    const project = this.selectedProject;
    d.saving = true;
    d.error = '';
    this.editProject(project, true);
    this.projectForm.patchValue({ [d.field]: d.draft });
    this.projectForm.markAsDirty();
    this.persistProjectData(
      () => {
        project[d.field] = d.draft;
        this.viewOnly = true;
        this.disableSave = false;
        this.projectTextDialog = null;
      },
      (message: string) => {
        this.viewOnly = true;
        this.projectForm.markAsPristine();
        if (this.projectTextDialog) this.projectTextDialog = { ...d, saving: false, error: message || 'Could not save. Please try again.' };
      },
      true
    );
  }

  onProjectTextKeydown(event: KeyboardEvent): void {
    if ((event.metaKey || event.ctrlKey) && event.key === 'Enter') {
      event.preventDefault();
      this.saveProjectText();
    }
  }

  get requestedByOptions(): string[] {
    const names = this.organizationContacts.length
      ? this.organizationContacts.map(c => this.contactName(c))
      : (this.requestedPersons || []).map((p: any) => p?.name);
    const current = this.projectForm.getRawValue().requestedBy;
    const options = names.filter(Boolean);
    if (current && !options.includes(current)) options.unshift(current);
    return Array.from(new Set(options));
  }

  get projectServiceTypeLabel(): string {
    const value = this.selectedProject?.serviceType;
    return this.serviceTypes.find(type => type.value === value)?.label || value || '';
  }

  getMissingRequiredProjectFields(): string[] {
    const labels: { [k: string]: string } = {
      organizationId: 'Organization Name',
      matterId: 'Matter Name',
      name: 'Project Name',
      startDate: 'Start Date',
      dueDate: 'Due Date',
      isEnforceEstimatedTime: 'Enforced Estimated Time',
      projectTypeId: 'Project Type',
      statusCode: 'Status',
      priorityCode: 'Priority',
      lpcUserId: 'LPC',
      isBillable: 'Billable',
      nonBillableReason: 'Non Billable Reason',
      holdTimeUntilCompleted: 'Hold Time Until Completed',
      isPreInvoiced: 'Pre Invoiced'
    };
    const missing: string[] = [];
    Object.keys(labels).forEach((key) => {
      const ctrl = this.projectForm.get(key);
      if (ctrl && ctrl.enabled && ctrl.errors?.['required']) {
        missing.push(labels[key]);
      }
    });
    return missing;
  }

  getProjectStatusDisabledReason(): string {
    const project = this.projectForm.getRawValue();
    if (project.isPreInvoiced === 'Yes' && !project.invoiceNumber) {
      return 'Status remains Pending Payment until an invoice number is recorded.';
    }
    if (project.submitToBilling === 'Yes') {
      return '';
    }
    return 'Status is locked for this project.';
  }

  getPreInvoicedDisabledReason(): string {
    const project = this.projectForm.getRawValue();
    if (project.submitToBilling === 'Yes') {
      return 'Pre-invoiced cannot be changed after the project is submitted to billing.';
    }
    if (project.createdOn && !this.checkPreInvoicedNewProject(project)) {
      return 'Pre-invoiced is not editable for projects created before the pre-invoice launch.';
    }
    return 'Pre-invoiced is locked for this project.';
  }

  getInvoiceNumberDisabledReason(): string {
    const project = this.projectForm.getRawValue();
    if (!this.authService.roles.includes('Billing')) {
      return 'Only users with the Billing role can update the invoice number.';
    }
    if (project.submitToBilling !== 'Yes') {
      return 'Available after the project is submitted to billing.';
    }
    return 'Invoice number is locked for this project.';
  }

  getInvoicePaidDisabledReason(): string {
    const project = this.projectForm.getRawValue();
    if (this.isYes(project.isInvoicePaid)) {
      return 'Payment is already recorded and cannot be changed here.';
    }
    if (!this.authService.roles.includes('Billing')) {
      return 'Only users with the Billing role can update invoice payment.';
    }
    if (project.submitToBilling !== 'Yes') {
      return 'Available after the project is submitted to billing.';
    }
    return 'Invoice payment is locked for this project.';
  }

  confirmCloseProject() {
    if (this.projectForm?.dirty && !this.viewOnly) {
      this.discardConfirm = 'project';
    } else {
      this.closeDialog();
    }
  }

  private parseCurrency(raw: any): number {
    if (raw === null || raw === undefined || raw === '') {
      return 0;
    }
    const parsed = parseFloat(String(raw).replace(/[^0-9.\-]/g, ''));
    return isNaN(parsed) ? 0 : parsed;
  }

  get hasProjectBudget(): boolean {
    return this.parseCurrency(this.projectForm?.getRawValue()?.estimatedBudget) > 0;
  }

  get budgetUsedPercent(): number {
    const estimate = this.parseCurrency(this.projectForm?.getRawValue()?.estimatedBudget);
    if (estimate <= 0) {
      return 0;
    }
    const spend = this.parseCurrency(this.projectForm?.getRawValue()?.actualSpend);
    return Math.max(0, Math.min(100, (spend / estimate) * 100));
  }

  get isOverBudget(): boolean {
    const estimate = this.parseCurrency(this.projectForm?.getRawValue()?.estimatedBudget);
    if (estimate <= 0) {
      return false;
    }
    return this.parseCurrency(this.projectForm?.getRawValue()?.actualSpend) > estimate;
  }

  @HostListener('document:keydown.escape')
  onProjectDialogEscape() {
    if (!this.projectDialog || this.discardConfirm || this.isOverlayAboveProjectDialog()) {
      return;
    }
    this.confirmCloseProject();
  }

  private isOverlayAboveProjectDialog(): boolean {
    if (this.hasVisibleElement('.swal2-container, .p-dropdown-panel, .p-multiselect-panel, .p-autocomplete-panel, .p-overlaypanel, .p-confirm-popup, .p-datepicker:not(.p-datepicker-inline)')) {
      return true;
    }
    const wrapper = document.querySelector('.al-project-dialog')?.closest('.p-dialog-mask') as HTMLElement | null;
    if (!wrapper) {
      return true;
    }
    const ownZ = this.overlayZIndex(wrapper);
    const masks = document.querySelectorAll('.p-dialog-mask');
    for (let i = 0; i < masks.length; i++) {
      const mask = masks[i] as HTMLElement;
      if (mask !== wrapper && mask.getClientRects().length && this.overlayZIndex(mask) >= ownZ) {
        return true;
      }
    }
    return false;
  }

  private hasVisibleElement(selector: string): boolean {
    const nodes = document.querySelectorAll(selector);
    for (let i = 0; i < nodes.length; i++) {
      if ((nodes[i] as HTMLElement).getClientRects().length) {
        return true;
      }
    }
    return false;
  }

  private overlayZIndex(el: HTMLElement): number {
    return parseInt(el.style.zIndex, 10) || 0;
  }

  focusNewProjectName(): void {
    if (this.newProject && this.projectForm.controls['name'].enabled && !this.viewOnly) {
      this.projectNameInput?.nativeElement.focus();
    }
  }

  exitProjectWorkspace() {
    this.showProjectsView = false;
    this.closeDialog();
  }

  closeDialog() {
    this.projectDialog = false;
    this.newProject = false;
    this.showProjectNotesPanel = true;
    this.openProjectGroups = [0, 1, 2, 3, 4];
    this.submitted = false;
    this.disableSave = false;
    this.btnLoading = false
    this.isDropdownOpen = false;
    this.allOrganisations = this.DbOrganisations;
    this.mattersList = [];
    this.reminderDialog = false;
    this.reminderNotificationDialog = false;
    this.messageService.clear();
    this.faloading = false;
    this.auditDialog = false;
    this.gridSettingsDialog = false;
    this.projectForm.markAsPristine();
    if (this.showProjectsView) {
      this.viewOnly = true;
    } else {
      this.viewOnly = false;
      this.selectedProject = { projectTasks: [] };
      this.taskTreeNodes = [];
      this.clearSelection();
      this.viewProjectName = "";
      this.projectWorkspaceTabIndex = 0;
      this.showFullProjectNotes = false;
    }
    this.loadProjectsData(this.lastTableLazyLoadEvent);
  }
  saveProject(saveBtnClicked?: any, confirmed?: any) {
    this.projectForm.value.startDate = this.datePipe.transform(this.projectForm.value.startDate, "MM/dd/yyyy")
    this.projectForm.value.dueDate = this.datePipe.transform(this.projectForm.value.dueDate, "MM/dd/yyyy")
    this.projectForm.value.closedDate = this.projectForm.value.closedDate ? this.datePipe.transform(this.projectForm.value.closedDate, "MM/dd/yyyy") : null
    // this.projectForm.value.estimatedTime = this.filterService.convertDateToTime(this.projectForm.value.estimatedTime)
    // this.projectForm.value.actualTime = this.filterService.convertDateToTime(this.projectForm.value.actualTime)
    // this.projectForm.value.matterName = "TEST MATTER"
    // this.projectForm.value.organizationName = "TEST ORGANIZATION"
    // this.projectForm.value.projectTemplateName="TEST TEMPLATE NAME"

    // if(saveCloseDate==false){
    //   this.showConfirmAlert=false;
    //   this.closeDialog()
    //   return;
    // }



    if (this.btnLoading)
      return;


    this.messageService.clear();

    this.submitted = true;
    if (this.projectForm.valid) {
      if (this.projectForm.controls['isPreInvoicedDb'].value == "No" && this.projectForm.controls['isPreInvoiced'].value == "Yes" && this.projectForm.controls['projectTaskCount']?.value) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Delete all tasks and associated time records if any before changing Pre invoice ( only if Pre invoice change)' });
        this.btnLoading = false;
        return;
      }
      if (saveBtnClicked && this.projectForm.value.holdTimeUntilCompleted == "Yes" && this.projectForm.value.statusCode == "Completed") {
        this.confirmMessage = "You are Completing a Project marked as Hold Time Until Completed. By Completing this Project, all Time will be released and invoiced to the Client. Are you sure you want to Complete this Project?";
        this.showConfirmAlert = true;
        return;
      }
      if (saveBtnClicked && this.projectForm.value.holdTimeUntilCompleted == "Yes" && this.projectForm.value.dbProjectStatusCode == "Completed" && this.projectForm.value.statusCode == "In Progress") {
        this.confirmMessage = `You are changing the status of a Completed Project back to In Progress for a Project marked as Hold Time Until Completed.All Time Records have already been released and invoiced for this Project. 
                            By changing the status back to In Progress, only Time Records submitted from this date forward will be held until this Project is marked Completed. Are you sure you want to change the status of this Project?
                            `;
        this.showConfirmAlert = true;
        return;
      }
      if (saveBtnClicked && this.projectForm.value.holdTimeUntilCompleted == "No" && this.projectForm.value.dbProjectholdTimeUntilCompleted == "Yes") {
        this.confirmMessage = `You are changing Hold Time Until Completed to No. All existing Records will be released and invoiced for this Project. Are you sure you want to change Hold Time Until Completed for this Project? `;
        this.showConfirmAlert = true;
        return;
      }
      // if(saveBtnClicked&& this.projectForm.getRawValue().invoiceNumber && !this.projectForm.getRawValue().isInvoicePaid){
      //   this.btnLoading=false;
      //   this.messageService.add({ severity: 'error', detail: "Invoice Paid is mandatory if Invoice Number is provided" });
      //   return;
      // }
      if (saveBtnClicked && !this.projectForm.getRawValue().invoiceNumber && this.projectForm.getRawValue().isInvoicePaid) {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', detail: "Invoice Number is mandatory if Invoice Paid is provided" });
        return;
      }

      if (saveBtnClicked && this.projectForm.getRawValue().invoiceNumber && this.projectForm.getRawValue().invoiceNumber.length > 20) {
        this.btnLoading = false;
        this.messageService.add({ severity: 'error', detail: "Invoice Number should be less than 20 characters" });
        return;
      }

      if (confirmed == false) {
        this.showConfirmAlert = false;
        this.closeDialog();
        return;
      }
      // if((this.projectForm.value.closedDate && !saveCloseDate) && (this.projectClosedData==null ||this.filterService.compareDate(this.projectClosedData,new Date(this.projectForm.value.closedDate))!=0)){
      if (this.projectForm.getRawValue().closedDate||this.projectForm.getRawValue().statusCode == "Completed") {
        this.btnLoading = true;
        try {
          let id = this.projectForm.controls['id'].value
          if (id) {
            this.projectService.getAllPendingItems(id).subscribe(
              res => {
                let str = ""
                if (res.data.pendingTask.length) {
                  str = str + "This Project has  " + res.data.pendingTask.length + " pending Tasks "
                }
                if (res.data.pendingTimerecords.length) {
                  if (res.data.pendingTask.length)
                    str = str + "and " + res.data.pendingTimerecords.length + " pending TimeRecords. "
                  else
                    str = str + "This Project has " + res.data.pendingTimerecords.length + " pending TimeRecords. "
                }
                if (str != "") {
                  str = str + "Please complete pending items before closing this Project."
                  this.btnLoading = false;
                  this.disableSave = true;
                  this.showConfirmAlert = false;
                  this.messageService.add({ severity: 'error', detail: str });
                } else {
                  this.persistProjectData();
                }

              }, res => {
                this.btnLoading = false;
                this.showConfirmAlert = false;
                this.messageService.add({ severity: 'error', detail: res.error.message });
              })
          } else {
            this.persistProjectData();
          }
        } catch (error: any) {
          this.btnLoading = false;
          console.log(error)
          this.showConfirmAlert = false;
          this.messageService.add({ severity: 'error', detail: error.message });
        }
      } else {
        this.persistProjectData();
      }


    }
  }

  persistProjectData(onSuccess?: () => void, onError?: (message: string) => void, singleFieldUpdate = false) {
    this.btnLoading = true;
    const id = this.projectForm.controls['id'].value
    if (!this.projectForm.controls['id'].value)
      delete this.projectForm.value.id
    let payload: any = {}
    payload = this.projectForm.getRawValue();
    payload.startDate = payload.startDate ? this.datePipe.transform(payload.startDate, "MM/dd/yyyy") : null;
    payload.dueDate = payload.dueDate ? this.datePipe.transform(payload.dueDate, "MM/dd/yyyy") : null;
    payload.closedDate = payload.closedDate ? this.datePipe.transform(payload.closedDate, "MM/dd/yyyy") : null
    payload.actualSpend = null;
    payload.estimatedBudget = null;
    payload.holdTimeUntilComp = payload.holdTimeUntilCompleted;
    delete payload.dbProjectStatusCode
    delete payload.dbProjectholdTimeUntilCompleted
    this.showConfirmAlert = false;
    // if (this.authService.roles.includes('Billing')&& this.authService.roles.length == 1) {
    //   payload.statusCode = "In Progress";
    // }
    if(!singleFieldUpdate && this.authService.roles.includes('Billing')){
      if(this.projectForm.getRawValue().statusCode=="Submitted to Billing" && this.projectForm.getRawValue().submitToBilling=="Yes" 
        && this.projectForm.getRawValue().isInvoicePaid==true && this.projectForm.getRawValue().invoiceNumber){
        payload.statusCode = "In Progress";
        payload.isBillingUpdate = "Yes";
      }
    }

    payload.isInvoicePaid = this.projectForm.getRawValue().isInvoicePaid ? 'Yes' : 'No';
    payload.submitToBilling = this.projectForm.getRawValue().submitToBilling ? this.projectForm.getRawValue().submitToBilling : 'No';
    payload.estimatedTime = this.filterService.convertStrToNum(payload.estimatedTime)
    payload.actualTime = this.filterService.convertStrToNum(payload.actualTime)
    const disabledProjectControls = Object.keys(this.projectForm.controls)
      .filter((controlName) => this.projectForm.controls[controlName].disabled);
    const restoreProjectControlState = () => {
      this.projectForm.enable({ emitEvent: false });
      disabledProjectControls.forEach((controlName) => {
        this.projectForm.controls[controlName].disable({ emitEvent: false });
      });
    };
    this.projectForm.disable({ emitEvent: false });
    try {
      this.projectService.saveProject(payload, id).subscribe(
        res => {
          this.btnLoading = false;
          if (res.message) {
            this.disableSave = true;
            this.submitted = false;
            this.projectForm.markAsPristine();
            this.messageService.add({ severity: 'success', detail: 'Project ' + this.projectForm.controls['name'].value + ' details have been saved successfully' });
            onSuccess?.();
          } else {
            restoreProjectControlState();
            this.messageService.add({ severity: 'error', detail: res.message });
            onError?.(res.message);
          }
          this.showConfirmAlert = false;
        }, res => {
          this.btnLoading = false;
          restoreProjectControlState();
          this.messageService.add({ severity: 'error', detail: res.error.message });
          onError?.(res?.error?.message);
        })
    } catch (error: any) {
      this.btnLoading = false;
      restoreProjectControlState();
      console.log(error)
      this.messageService.add({ severity: 'error', detail: error.message });
      onError?.(error.message);
    }
  }

  get name() {
    return this.projectForm.get('name');
  }
  get projectTemplateId() {
    return this.projectForm.get('projectTemplateId');
  }
  get startDate() {
    return this.projectForm.get('startDate');
  }
  get closedDate() {
    return this.projectForm.get('closedDate');
  }
  get dueDate() {
    return this.projectForm.get('dueDate');
  }
  get estimatedTime() {
    return this.projectForm.get('estimatedTime');
  }
  get actualTime() {
    return this.projectForm.get('actualTime');
  }
  get estimatedBudget() {
    return this.projectForm.get('estimatedBudget');
  }
  get isEnforceEstimatedTime() {
    return this.projectForm.get('isEnforceEstimatedTime');
  }
  get projectTypeId() {
    return this.projectForm.get('projectTypeId');
  }
  get statusCode() {
    return this.projectForm.get('statusCode');
  }

  get priorityCode() {
    return this.projectForm.get('priorityCode');
  }
  get lpcUserId() {
    return this.projectForm.get('lpcUserId');
  }
  get isBillable() {
    return this.projectForm.get('isBillable');
  }
  get notes() {
    return this.projectForm.get('notes');
  }
  get description() {
    return this.projectForm.get('description');
  }
  get requestedBy() {
    return this.projectForm.get('requestedBy');
  }
  get matterId() {
    return this.projectForm.get('matterId');
  }
  get organizationId() {
    return this.projectForm.get('organizationId');
  }
  get holdTimeUntilCompleted() {
    return this.projectForm.get('holdTimeUntilCompleted');
  }
  get dbProjectStatusCode() {
    return this.projectForm.get('dbProjectStatusCode');
  }
  get invoiceNumber() {
    return this.projectForm.get('invoiceNumber');
  }
  get nonBillableReason() {
    return this.projectForm.get('nonBillableReason');
  }
  get isPreInvoiced() {
    return this.projectForm.get('isPreInvoiced');
  }

  openAssignTask(project: any) {
    this.title = "Create New Task"
    this.orgName = project.organizationName;
    this.matterName = project.matterName;
    this.selectedProjectName = project.name;
    this.assignTaskDialogue = true;
    this.transformTasks(project);


  }

  transformTasks(project: any) {

    this.tasksloading = true;
    this.btnLoading = false;
    this.projectService.getProjectUnassignedTasksList(project.id).subscribe(res => {
      project.unAssignedTasks = res.data.unAssignedTasks;
      project.projectTasks = res.data.projectTasks;

      const nodes = this.createTreeNodes(project.unAssignedTasks);

      // for (let k = 0; k < project.unAssignedTasks.length; k++) {
      //   let str = "";
      //   let taskFullName = project.unAssignedTasks[k].taskFullName ? project.unAssignedTasks[k].taskFullName : project.unAssignedTasks[k].taskName;
      //   if (taskFullName) {
      //     for (let j = 1; j < taskFullName.split(":").length; j++) {
      //       str = str + String.fromCharCode(160);
      //       str = str + String.fromCharCode(160);
      //       str = str + String.fromCharCode(160);
      //       str = str + String.fromCharCode(160);
      //       str = str + String.fromCharCode(160);
      //       str = str + String.fromCharCode(160);
      //       str = str + String.fromCharCode(160);
      //     }
      //     project.unAssignedTasks[k].taskName = str + project.unAssignedTasks[k].taskName;
      //     project.unAssignedTasks[k].disabled = project.unAssignedTasks[k].isHeader == "Yes" ? true : false;
      //     project.unAssignedTasks[k].description = project.unAssignedTasks[k].description ? project.unAssignedTasks[k].description : "No Description";
      //   }
      // }
      this.taskTreeNodes = nodes;
      // this.unAssignedTasks = project.unAssignedTasks
      this.selectedProject = project
      this.tasksloading = false;
    });
  }

  createTreeNodes(flatTasks: any[]): any[] {
    // 1. Initialize a map to hold all nodes, using the full path as the key (e.g., "Parent:Child")
    const nodesMap = new Map<string, any>();
    // 2. Initialize the array that will hold the final top-level nodes
    const rootNodes: any[] = [];

    // 3. First pass: Create or update all nodes (both parents and children)
    for (const task of flatTasks) {
      // Use taskFullName or taskName as the base for the hierarchy path
      const fullPath = task.taskFullName || task.taskName;
      if (!fullPath) continue;

      // Split the path into segments (e.g., ["Bankruptcy Services", "Bankruptcy Support (hourly)"])
      const segments = fullPath.split(':').filter((s: string) => s.trim() !== '');

      let currentPath = '';

      for (let i = 0; i < segments.length; i++) {
        const segmentName = segments[i].trim();
        const parentPath = currentPath;

        // Build the path key for the current node (e.g., "Bankruptcy Services" or "Bankruptcy Services:Bankruptcy Support (hourly)")
        currentPath = parentPath ? `${parentPath}:${segmentName}` : segmentName;

        // Check if this node already exists in our map
        let node = nodesMap.get(currentPath);

        if (!node) {
          // Node does not exist, so create it
          node = {
            expanded: true, // Default to expanded
            key: currentPath, // Use the full path as a unique key
            label: segmentName, // The display name is just the segment
            children: [],
            // Set default data properties
            data: {
              qbDescription: 'No Description',
              isHeader: 'No'
            },
            disabled: false // Default to not disabled
          };

          // Add the new node to the map
          nodesMap.set(currentPath, node);

          // If this is not a top-level node (i > 0), find its parent and link it
          if (parentPath) {
            const parentNode = nodesMap.get(parentPath);
            if (parentNode) {
              // Ensure parent's children array is initialized before pushing
              if (!parentNode.children) {
                parentNode.children = [];
              }
              parentNode.children.push(node);
            }
          } else {
            // This is a top-level node, add it to the root array
            rootNodes.push(node);
          }
        }

        // 4. Update the node properties only for the leaf/final node in the segment path
        // The leaf node is the one that contains the actual task data.
        if (i === segments.length - 1) {
          // Leaf node properties (from your original task object)
          node.data = {
            ...task, // Keep all original task properties in the 'data' payload
            qbDescription: task.qbDescription || "No Description"
          };
          // Set 'disabled' status based on your existing logic for the leaf node
          node.disabled = task.isHeader === "Yes";
        } else {
          // Header/Intermediate node properties (always disabled to act as a separator)
          node.disabled = true;
          // We keep the label of the header node as the segmentName
        }
      }
    }

    // 5. Cleanup: Remove nodes that have children and are marked as 'isHeader=="Yes"' 
    //    from the leaf node's task data, as the actual PrimeNG node structure already handles it.
    //    We only return the root nodes array.
    return rootNodes;
  }


  closeAssignTaskDialogue() {
    this.assignTaskDialogue = false;
    if (!this.showProjectsView) this.selectedProject.id = null;
    this.closeDialog();
    // this.loadProjectsData(this.lastTableLazyLoadEvent);
  }

  assignTask(assignFlag: any = null) {
    this.messageService.clear();

    if (this.selectedProject?.isPreInvoiced?.toUpperCase() != 'YES' && assignFlag == null
      && this.newTask?.disbursementRelated?.toUpperCase() == "YES") {
      this.showAssignConfirmAlert = true;
      this.confirmMessage = `This Project is not Pre-Invoiced as defined by Client’s 
      Preferred Payment Method, and Disbursement Tasks for this Project will be billed additionally. 
      Are you sure you want to Add this Task?`;
      return;
    }

    if (assignFlag == false) {
      this.assignLoading = false;
      this.showAssignConfirmAlert = false;
      this.confirmMessage = '';
      return;
    }

    if (assignFlag == true) {
      this.showAssignConfirmAlert = false;
      this.confirmMessage = '';
    }

    const payload = {
      projectId: this.selectedProject.id,
      taskIds: [this.newTask.id]
    }
    if (this.assignLoading) return;
    this.assignLoading = true;
    try {
      this.taskService.assignTask(payload).subscribe(
        res => {
          if (res.message) {
            this.newTask = "";
            this.clearSelection();
            this.loadProjectsData(this.lastTableLazyLoadEvent, true);
            this.projectTaskGrid?.reloadTasks();

          } else {
            this.assignLoading = false;
            this.messageService.add({ severity: 'error', detail: res.message });
          }
        }, res => {
          this.assignLoading = false;
          console.log(res.error)
          this.messageService.add({ severity: 'error', detail: res.error.message });
        })
    } catch (error: any) {
      this.assignLoading = false;
      console.log(error)
      this.messageService.add({ severity: 'error', detail: error.message });
    }
  }

  refreshProjectTaskCount() {
    this.loadProjectsData(this.lastTableLazyLoadEvent, true);
  }

  deleteTask(task: any) {
    if (this.deleteTaskLoading) return;
    this.deleteTaskLoading = true;
    this.messageService.clear();
    try {
      this.taskService.deleteTask({projTaskId: task.id}).subscribe(
        (res:any) => {
          this.loadProjectsData(this.lastTableLazyLoadEvent, true);
          this.projectTaskGrid?.reloadTasks();
          if (res.message) {
            // this.deleteTaskLoading = false;
            // this.messageService.add({ severity: 'success', detail: 'Task details have been deleted successfully' });
          } else {
            // this.taskForm.enable();
            this.deleteTaskLoading = false;
            this.messageService.add({ severity: 'error', detail: res.message });
          }
        }, (res:any) => {
          this.deleteTaskLoading = false;
          // this.taskForm.enable();
          console.log(res.error)
          this.messageService.add({ severity: 'error', detail: res.error.message });
        })
    } catch (error: any) {
      this.deleteTaskLoading = false;
      // this.taskForm.enable();
      console.log(error)
      this.messageService.add({ severity: 'error', detail: error.message });
    }
  }

  onDateFilterChange(field: any) {
    this.filterDates[field] = null
  }

  clearDatesFilter(field: any) {
    console.log('Clear date filter', field);
    this.filterDates[field] = null;
    this.dateFilters = this.dateFilters.filter((filter: any) => filter.field !== field);
    this.loadProjectsData(this.lastTableLazyLoadEvent);
  }
  applyDatesFilter(field: any) {
    console.log("apply", this.filterDates[field], this.filterDatesMatchModes[field]);
    let dates = this.filterDates[field]
    const index = this.dateFilters.findIndex((filter: any) => filter.field === field);
    if (index > -1) {
      this.dateFilters.splice(index, 1);
    }
    if (this.filterDatesMatchModes[field] == 'betweenDate') {
      this.dateFilters.push({
        field: field, operator: "betweenDate", value: this.filterService.convertDateToFormattedPayloadStr(dates[0]),
        valueTo: this.filterService.convertDateToFormattedPayloadStr(dates[1])
      });
    } else {
      this.dateFilters.push({ field: field, operator: this.filterDatesMatchModes[field], value: this.filterService.convertDateToFormattedPayloadStr(dates) });
    }
    this.loadProjectsData(this.lastTableLazyLoadEvent);
  }

  /**
   * Apply widget filters to the table UI components
   */
  applyWidgetFiltersToUI(): void {
    if (!this.table || !this.widgetFilters || this.widgetFilters.length === 0) {
      return;
    }

    try {
      // Get or initialize the filters object on the table
      if (!this.table.filters) {
        this.table.filters = {};
      }

      this.widgetFilters.forEach((filter: any) => {
        if (filter.field === 'statusCode' && filter.operator === 'in' && filter.values) {
          // For statusCode with 'in' operator, we need to set the multiselect values
          // The multiselect expects an array of objects with {label, value} structure
          // Convert the values array to match the statuses array structure
          const statusObjects = filter.values.map((statusValue: string) => {
            const status = this.statuses.find((s: any) => s.value === statusValue || s.label === statusValue);
            return status || { label: statusValue, value: statusValue };
          });

          console.log('Widget status filter values:', filter.values);
          console.log('Mapped to status objects:', statusObjects);

          // Set the filter value with the array of status objects
          this.table.filters['statusCode'] = [{ value: statusObjects, matchMode: 'in' }];
          console.log('Applied statusCode filter to UI');
        }
        else if (filter.field === 'lpcUserEmail' && filter.operator === 'equals' && filter.value) {
          // For lpcUserEmail with 'equals' operator, set contains filter
          this.table.filters['lpcUserEmail'] = [{ value: filter.value, matchMode: 'contains' }];
          console.log('Applied lpcUserEmail filter to UI:', filter.value);
        }
      });

      // Trigger change detection to update the UI
      this.cdr.detectChanges();
    } catch (error) {
      console.error('Error applying widget filters to UI:', error);
    }
  }

  clearAllFilters(table: Table) {
    this.router.navigateByUrl("/projects");
    this.notifyProjectIdPayload = null;
    this.lastSelectedStatus = 'Any';
    this.selectedFilterOption = 'All Projects';
    this.searchTerm = '';
    this.dateFilters = [];
    this.widgetFilters = []; // Clear widget filters as well
    Object.keys(this.filterDatesMatchModes).map((field: any) => this.filterDatesMatchModes[field] = '')
    Object.keys(this.filterDates).map((field: any) => this.filterDates[field] = null)
    table.clear();
  }

  onDateSelect(field: any, event: any) {
    if (this.filterDatesMatchModes[field] == 'betweenDate' && this.filterDates[field].length == 2 && this.filterDates[field][0] && this.filterDates[field][1]) {
      const calendarElement = document.querySelector('.p-calendar');
      if (calendarElement) {
        const overlay = document.querySelector('.p-datepicker');
        if (overlay)
          (overlay as HTMLElement).style.display = 'none';
      }
    }
  }

  submitToBilling(project?: any, confirmFlag?: any) {
    if (confirmFlag == null) {
      this.selectedProjectForBilling = project
      this.confirmMessage = `Submitting this Project to Billing will lock the Project until Billing is complete. 
          Are you sure you want to submit this Project to 
          Billing?`;
      this.showBillingConfirmAlert = true;
      return;
    }
    if (confirmFlag == false) {
      this.showBillingConfirmAlert = false;
      this.confirmMessage = '';
      return;
    }

    if (!project)
      project = this.selectedProjectForBilling

    let payload: any = {};
    payload['name'] = project.name;
    payload['submitToBilling'] = "Yes";
    payload['statusCode'] = "Submitted to Billing";

    this.showBillingConfirmAlert = false;
    this.confirmMessage = ""

    this.loading = true;

    this.projectService.submitToBilling(project.id, payload).subscribe(
      res => {
        if (res.data.message) {
          this.loadProjectsData(this.lastTableLazyLoadEvent, true);
        }
        Swal.fire(res.data.message ? res.data.message : "Submitted to Billing Successfully!");
      }, res => {
        console.log(res.error)
        this.loading = false;
        Swal.fire(res.error?.message ? res.error.message : "Failed to submit to Billing!");
      })
  }

  getFieldInfo(fieldKey: string): FieldInfo | undefined {
    if (!this.fieldInfoReady) return undefined;
    return this.fieldInfoService.getAllFields().find((f: FieldInfo) => f.gridName === 'Project' && f.fieldKeyName === fieldKey);
  }

  exportProjects() {
    // Reuse the same payload builder to ensure consistency
    let payload = this.buildProjectPayload(this.lastTableLazyLoadEvent || {} as LazyLoadEvent);

    this.btnLoading = true;
    this.projectService.exportProjects(payload,this.activeTab).subscribe(
      (res: any) => {
        this.btnLoading = false;
        const responseBody = res.body;
        const contentType = res.headers.get('Content-Type');

        // Check for CSV, Excel, or octet-stream content types
        if (responseBody && responseBody instanceof ArrayBuffer && responseBody.byteLength > 0) {
          const contentDisposition: any = res.headers.get('Content-Disposition');
          let filename = 'projects_export.xlsx'; // Default to Excel

          // Extract filename from Content-Disposition header
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
            if (filenameMatch && filenameMatch[1]) {
              filename = filenameMatch[1].replace(/['"]/g, '');
            }
          } else if (contentType) {
            // If no Content-Disposition, determine extension from Content-Type
            if (contentType.includes('spreadsheetml.sheet') || contentType.includes('vnd.openxmlformats')) {
              filename = 'projects_export.xlsx';
            } else if (contentType.includes('vnd.ms-excel')) {
              filename = 'projects_export.xls';
            } else if (contentType.includes('text/csv')) {
              filename = 'projects_export.csv';
            }
          }

          this.downloadFile(responseBody, filename);
          this.messageService.add({ severity: 'success', detail: 'Projects exported successfully!' });
        } else {
          Swal.fire("Nothing to Export.");
        }
      },
      (error) => {
        this.btnLoading = false;
        console.error('Export error:', error);
        this.messageService.add({ severity: 'error', detail: 'Failed to export projects' });
      }
    );
  }

  getExportDisabledReason(): string {
    return this.btnLoading ? 'Export already in progress. Please wait.' : '';
  }

  getSaveDisabledReason(): string {
    if (this.btnLoading) {
      return 'Project update is in progress.';
    }
    if (this.disableSave) {
      return 'Complete pending tasks/time records or reopen the form before saving.';
    }
    if (!this.projectForm.dirty) {
      return 'No changes to save.';
    }
    return '';
  }

  get projectSaveDisabled(): boolean {
    return this.disableSave || this.btnLoading || !this.projectForm.dirty;
  }

  getCreateTaskDisabledReason(): string {
    return !this.newTask ? 'Select a task from the dropdown before creating.' : '';
  }

  downloadFile(data: ArrayBuffer, filename: string) {
    // Add timestamp to filename if not already present
    const now = new Date();
    const timestamp = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0') + '_' +
      String(now.getHours()).padStart(2, '0') + '-' +
      String(now.getMinutes()).padStart(2, '0') + '-' +
      String(now.getSeconds()).padStart(2, '0');

    const filenameParts = filename.split('.');
    const extension = filenameParts.pop();
    const baseName = filenameParts.join('.');

    // Check if filename already has a timestamp pattern
    if (!baseName.match(/\d{4}-\d{2}-\d{2}_\d{2}-\d{2}-\d{2}/)) {
      filename = `${baseName}_${timestamp}.${extension}`;
    }

    // Determine MIME type based on file extension
    let mimeType = 'application/octet-stream';
    if (extension === 'xlsx') {
      mimeType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    } else if (extension === 'xls') {
      mimeType = 'application/vnd.ms-excel';
    } else if (extension === 'csv') {
      mimeType = 'text/csv';
    }

    const blob = new Blob([data], { type: mimeType });
    const downloadLink = document.createElement('a');
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = filename;
    downloadLink.click();
    URL.revokeObjectURL(downloadLink.href);
  }

  selectedTaskNode: TreeNode<any> | null = null;
  displaySelectedTask: string = 'Select Task';

  /**
     * Toggles the visibility of the custom dropdown panel.
     */
  toggleDropdown(): void {
    this.isDropdownOpen = !this.isDropdownOpen;
  }

  /**
   * Handles the selection of a node from the p-tree.
   * @param event The p-tree node select event.
   */
  onNodeSelect(event: any): void {
    const selectedNode: any = event.node;

    // 1. Single Selection Logic: Only allow selection of non-disabled leaf nodes
    if (!selectedNode.disabled && (!selectedNode.children || selectedNode.children.length === 0)) {
      this.selectedTaskNode = selectedNode;
      this.displaySelectedTask = selectedNode.label || selectedNode.data?.taskName || 'Selected Task';
      this.isDropdownOpen = false;
      this.newTask = selectedNode.data;
    }
  }

  /**
   * Clears the current selection.
   */
  clearSelection(): void {
    this.selectedTaskNode = null;
    this.displaySelectedTask = 'Select Task';
    this.newTask = null;
  }

  clicked(project: any) {
    this.selectedProject = project;
    this.viewProject(project, true);
    this.showProjectsView = true;
    this.loadWorkspaceContacts(project?.id);
    this.showFullProjectNotes = false;
    this.showFullProjectDescription = false;
    this.projectWorkspaceTabIndex = 0;
    this.viewOnly = true;
    this.viewProjectName = project.name;
  }

  getProjectDetailsSummary(): string {
    const fields = [
      'organizationName', 'matterName', 'name', 'projectTypeCode', 'priorityCode',
      'projectTemplateName', 'description', 'statusCode', 'lpcUserEmail', 'requestedBy',
      'startDate', 'dueDate', 'closedDate', 'isBillable', 'nonBillableReason',
      'isEnforceEstimatedTime', 'holdTimeUntilCompleted', 'createdBy', 'createdOn',
      'updatedBy', 'updatedOn', 'isPreInvoiced', 'submitToBilling', 'invoiceNumber',
      'isInvoicePaidString'
    ];
    const count = fields.filter((field: string) => {
      const value = this.selectedProject?.[field];
      return value !== null && value !== undefined && value !== '';
    }).length;
    const summary = [count + ' fields'];
    if (this.selectedProject?.notes) summary.push('notes');
    summary.push('billing');
    return summary.join(' · ');
  }
  restoreSavedState(saved: any) {
    const event = saved.event;
    const cf = saved.customFilters;
    const widgetState = history.state;

    if (widgetState && widgetState.filters && (widgetState.fromWidget || widgetState.fromEntity|| widgetState.fromScreen)) {
      return; // Skip saving state if navigated from widget or entity with filters
    }

    // Restore custom component filters
    // this.projectMatterFilter = cf.projectMatterFilter;
    // this.projectOrgFilter = cf.projectOrgFilter;
    // this.lastSelectedStatus = cf.lastSelectedStatus;
    this.dateFilters = cf.dateFilters;
    // this.widgetFilters = cf.widgetFilters;
    this.selectedFilterOption = cf.selectedFilterOption;
    this.searchTerm = cf.searchTerm;

    setTimeout(() => {
      if (this.table) {
        const filtersAreValid = event.filters && Object.keys(event.filters).length > 0;

        // 2. Assign filters: Use saved filters if valid, otherwise use the captured default filters.
        if (filtersAreValid) {
          this.table.filters = event.filters;
        } else if (Object.keys(this.defaultFilters).length > 0) {
          // 🔥 Use the default structure as a fallback to prevent empty filter popups
          this.table.filters = this.defaultFilters;
        }
        this.table.sortField = event.sortField ?? '';
        this.table.sortOrder = event.sortOrder ?? 0;

        this.table.sortSingle();

        this.table.first = event.first ?? 0;
        this.table.rows = event.rows ?? 10;

        this.table.onLazyLoad.emit(event);
      }
    }, 50);

    this.initialLoadDone = true;
  }

  saveState(event: LazyLoadEvent) {
    if (this.notifyProjectIdPayload)
      return; // Skip saving state when navigating from notification to prevent overwriting with stale state

    const widgetState = history.state;

    if (widgetState && widgetState.filters && (widgetState.fromWidget || widgetState.fromEntity|| widgetState.fromScreen)) {
      return; // Skip saving state if navigated from widget or entity with filters
    }
    const state: SavedTableState = {
      event: {
        first: event.first,
        rows: event.rows,
        sortField: event.sortField,
        sortOrder: event.sortOrder,
        filters: event.filters
      },
      customFilters: {
        projectMatterFilter: this.projectMatterFilter,
        projectOrgFilter: this.projectOrgFilter,
        lastSelectedStatus: this.lastSelectedStatus,
        dateFilters: this.dateFilters,
        widgetFilters: this.widgetFilters,
        selectedFilterOption: this.selectedFilterOption,
        searchTerm: this.searchTerm
      }
    };

    this.tableStateService.saveState(this.screenName + this.activeTab, this.authService.jwtData.email, state);
  }


  ngAfterViewInit() {
    // Capture the table's initial, un-filtered state structure
    // This needs a slight delay to ensure the table component is ready.
    setTimeout(() => {
      if (this.table && this.table.filters) {
        // Deep clone the initial filters to use as a fallback
        this.defaultFilters = JSON.parse(JSON.stringify(this.table.filters));
      }
    });
  }

  
  clearWidgetsFilter(){
    this.widgetFilters = [];
    this.filterSource = '';
    history.state.fromWidget = false;
    history.state.fromEntity = false;
    history.state.fromScreen = null;
    history.state.filters = null;
    const saved = this.tableStateService.getState(this.screenName+this.activeTab, this.authService.jwtData.email);

    if (saved && !this.initialLoadDone) {
      this.restoreSavedState(saved);
    } 
  }
  showAuditData(id:any,fieldName: string,header:string) {
    this.auditField=fieldName;
    this.auditRecordId=id;
    this.auditTitle = "Audit History for " + header +" ["+this.auditRecordId+"]";
    this.auditDialog = true;
  }
  closeAuditDialog() {
    this.auditDialog = false;
    this.auditRecordId=null;
    this.auditField='';
  }

  openReminderDialog(project: any) {
    this.reminderDialog = true;
    this.selectedProject = project;
  }

  // openReminderNotificationDialog(project: any) {
  //   this.reminderNotificationDialog = true;
  //   this.selectedProject = project;
  // }
  openReminderNotificationDialog(project: any) {
    this.loading = true;
    let payload={"filters":[{"field":"taskId","operator":"equals","value":project.id}, {"field":"commentTargetType","operator":"equals","value":"PROJECT NOTIFICATION"}],"sort":[],"category":"All Tasks","searchTerm":""};
    this.notificationService.getNotificationsPaginated(null,null,payload)
    .pipe(finalize(() => this.loading = false))
    .subscribe(res => {
      this.reminderNotificationDialog = true;
      this.selectedProject = project;
      this.selectedProject.unreadReminderNotifications = res.data.filter((n: any) => n.read == false);
    });
  }

  handleTableTabChange(event: any) {
    if (event.index == 0) {
      this.activeTab = "default";
    } else {
      this.activeTab = "user";
    }
    this.applyTabColumns();
  }
  fetchColumnSettings(): void {
    this.projectService.getTableSettings().subscribe(apiResponse => {
      apiResponse.defaultGridFields = this.sortByDisplayOrder(apiResponse.defaultGridFields || []);
      apiResponse.userViewGridFields = this.sortByDisplayOrder(apiResponse.userViewGridFields || []);
      apiResponse.availableFields = this.sortByDisplayOrder(apiResponse.availableFields || []);
      // Store the full objects, not just fieldKeyName
      this.defaultCols = Array.isArray(apiResponse?.defaultGridFields)
        ? apiResponse.defaultGridFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.customCols = Array.isArray(apiResponse?.userViewGridFields)
        ? apiResponse.userViewGridFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.availableColumns = Array.isArray(apiResponse?.availableFields)
        ? apiResponse.availableFields.filter((field: any) => field && field.fieldKeyName)
        : [];

      this.applyTabColumns();
    });
  }
  applyTabColumns(): void {
    // 1. Determine which reference list to use based on the tab
    const referenceList = this.activeTab === "default" ? this.defaultCols : this.customCols;

    // 2. Handle empty custom columns case
    if (this.activeTab !== "default" && (!referenceList || referenceList.length === 0)) {
        this.cols = [];
        return;
    }

    // 3. Map over the reference list to ensure its order is preserved
    this.cols = referenceList
        .map((ref: any) => {
            // Find the master definition in tableCols matching the reference field
            const masterCol = this.tableCols.find(col => col.field === ref.fieldKeyName);

            // Return the merged column with visible true, or null if not found
            return masterCol ? { ...masterCol, visible: true } : null;
        })
        .filter(col => col !== null); // Clean up any missing column matches

    if (this.activeTab === 'default' && !this.cols.some(col => col.field === 'serviceType')) {
      const serviceTypeColumn = this.tableCols.find(col => col.field === 'serviceType');
      if (serviceTypeColumn) {
        this.cols = [...this.cols, { ...serviceTypeColumn, visible: true }];
      }
    }

    const serviceTypeIndex = this.cols.findIndex(col => col.field === 'serviceType');
    const descriptionIndex = this.cols.findIndex(col => col.field === 'description');
    if (serviceTypeIndex >= 0 && descriptionIndex >= 0 && serviceTypeIndex > descriptionIndex) {
      const [serviceTypeColumn] = this.cols.splice(serviceTypeIndex, 1);
      this.cols.splice(descriptionIndex, 0, serviceTypeColumn);
    }

    this.cdr.detectChanges();

    if(this.resetcustomFilter && this.activeTab === "user"){
      this.clearAllFilters(this.table);
      this.resetcustomFilter=false;
    }else{
      const saved = this.tableStateService.getState(this.screenName+this.activeTab, this.authService.jwtData.email) as SavedTableState;

      if (saved) {
        this.restoreSavedState(saved);
      }
    }
  }

  isVisible(field: string): boolean {
    if (!field || !Array.isArray(this.cols)) return false;
    try{
      return this.cols.filter((c: any) =>  c.field === field && c.visible).length > 0;
    }
    catch(error){
      console.log('Error checking visibility for field:', field, this.cols);
      console.error('Error in isVisible:', error);
      return false;
    }
  }

  viewGridSettings() {
    this.gridSettingsDialog = true;
  }

  closeSettingsDialog() {
    this.gridSettingsDialog = false;
    this.fetchColumnSettings();
  }
  sortByDisplayOrder<T extends { displayOrder?: number }>(arr: T[]): T[] {
    return [...arr].sort((a, b) => {
      const aOrder = a.displayOrder ?? Number.MAX_SAFE_INTEGER;
      const bOrder = b.displayOrder ?? Number.MAX_SAFE_INTEGER;
      return aOrder - bOrder;
    });
  }

  saveCustomSettings() {
    // this.handleTableTabChange({ index: 1 });
    this.gridSettingsDialog = false;
    this.resetcustomFilter=true;
  }

  openGridSettings() {
    this.gridSettingsDialog = true;
  }

  getDefaultGridColumns(): any[] {
    // Hard code default columns for Project Name and ID
    return [
      {
        fieldKeyName: 'name',
        fieldName: 'Project Name'
      },
      {
        fieldKeyName: 'id',
        fieldName: 'ID'
      }
    ];
  }

  // Inside your component class
  getAuditCount(colField: string, project: any): number {
    const countMap: { [key: string]: number } = {
      'dueDate': project.dueDateChangeCount,
      'statusCode': project.projectStatusChangeCount,
    };

    // Return the specific count based on the field, or 0 if not found
    return countMap[colField] || 0;
  }
 
}
